import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-coe-home-page',
  templateUrl: './coe-home-page.component.html',
  styleUrls: ['./coe-home-page.component.css'],
})
export class CoeHomePageComponent implements OnInit {
  constructor(private router: Router) { }
  popup = false;
  /**
   * Initializes the component.
   * This sets up the component to be shown with a slight delay.
   * This is done to prevent the modal from showing up immediately,
   * which can be jarring to the user.
   */
  ngOnInit(): void {
    // Show the popup after a delay.
    // This is done to prevent the modal from showing up immediately,
    // which can be jarring to the user.
    setTimeout(() => {
      this.popup = true;
    }, 500); // Show after 500ms (0.5 seconds)

    // Check if the registration is closed.
    // If it is, the component should not be shown.
    this.checkRegistrationStatusCoE();
  }
  /**
   * Closes the popup by setting the `popup` property to false.
   * This is typically invoked when the user clicks the close button on the popup.
   */
  closePopup(): void {
    this.popup = false; // Close modal on button click
  }
  /**
   * Navigates to the COE registration page when the "Register" button is clicked.
   */
  preincubtorregister() {
    this.router.navigateByUrl('/coe-register');
  }
  /**
   * Navigates to the COE registration page when the "Register" button is clicked on the popup.
   */
  popUp() {
    this.router.navigateByUrl('/coe-register');
  }
  pdfUrl1 = 'assets/pdf/StartupTN - COE Document.pdf';
  viewingPdf1 = false;
  /**
   * Opens the COE Scheme Document PDF file in a new browser tab.
   */
  pdfDownload() {
    window.open(
      'https://startuptn-public-files.s3.ap-south-1.amazonaws.com/CoE_Scheme_Document.pdf',
      '_blank'
    );
  }
  /**
   * Opens the PDF file in a new browser tab.
   */
  openPdf1() {
    window.open(this.pdfUrl1, '_blank');
    this.viewingPdf1 = true;
  }
  /**
   * Downloads the PDF file using the FileSaver library.
   * @param {string} pdfUrl - The URL of the PDF file to download.
   * @param {string} pdfName - The filename to save the PDF as.
   */
  downloadPdf1() {
    const downloadLink = document.createElement('a');
    downloadLink.href = this.pdfUrl1;
    downloadLink.download = 'example.pdf';

    // Add the link to the document body
    document.body.appendChild(downloadLink);

    // Simulate a click on the link to download the PDF
    downloadLink.click();

    // Remove the link from the document body
    document.body.removeChild(downloadLink);

    // Hide the PDF viewer
    this.viewingPdf1 = false;
  }
  /**
   * Closes the edit and re-submit modal dialogs.
   * Hides both modals by setting their display property to 'none'.
   */
  closeModal(): void {
    // Hide the edit modal
    document.getElementById('editModal').style.display = 'none';

    // Hide the re-submit modal
    document.getElementById('reSubmitModal').style.display = 'none';
  }
  isRegistrationClosedCoE: boolean = false;
  /**
   * Checks if the registration for CoE is closed
   * @description Checks if the current date is after the registration deadline for CoE
   */
  checkRegistrationStatusCoE(): void {
    const deadline = new Date(2026, 2, 4, 11, 30, 0); // 4nd March 2026, 10:00 AM
    const now = new Date();
    // Set the isRegistrationClosedCoE flag based on the comparison
    this.isRegistrationClosedCoE = now >= deadline;
  }
}
